e.Me = e.Media_Manager = {
	init : function(){
		e.Me.google_drive.init();
		e.Me.all_media_items.init();
	}
};